import { IS_DEV, IS_TEST } from '../config';
import emitterEvents from '../constants/emitterEvents';
import { persistedDataLayer } from '../helpers/dataLayer';
import getTokens from '../helpers/getTokens';
import isAccessExpired from '../helpers/isAccessExpired';
import rejectedRefresh from '../helpers/rejectedRefresh';
import removeTokensFromLocalStorage from '../helpers/removeTokensFromLocalStorage';
import setTokensOnLocalStorage from '../helpers/setTokensOnLocalStorage';
import { logout, setLoggedIn } from './login';

export const SET_LOCAL_TOKENS = 'SET_LOCAL_TOKENS';
export const UNSET_LOCAL_TOKENS = 'UNSET_LOCAL_TOKENS';

const unsetLocalTokens = () => ({ type: UNSET_LOCAL_TOKENS });

const setLocalTokens = (value) => ({ type: SET_LOCAL_TOKENS, value });

const signalLogout = () => (dispatch) => {
  persistedDataLayer.flush();
  removeTokensFromLocalStorage();
  window.loginStateResolved = true;
  dispatch(logout());
  dispatch(unsetLocalTokens());
  window.emitter.emit(emitterEvents.loginState);
};

const readLocalTokens = () => (dispatch) => {
  getTokens().then(
    (tokens) => {
      setTokensOnLocalStorage(tokens);
      dispatch(setLocalTokens(tokens));
      if (!isAccessExpired(tokens)) {
        dispatch(setLoggedIn());
      }
    },
    (err) => {
      window.emitter.emit(emitterEvents.loginState, false);
      if (IS_DEV && !IS_TEST) {
        // eslint-disable-next-line no-console
        console.warn('No token available yet. Not logged in?', err);
      }
    }
  );
};

export {
  readLocalTokens,
  setLocalTokens,
  setLoggedIn,
  signalLogout,
  unsetLocalTokens,
  rejectedRefresh,
  logout,
};
